export default {
  SET_PROPERTIES (state, properties) {
    state.properties = properties
  },
  SET_PROPERTY (state, property) {
    state.properties.push(property)
  },
  SET_PROPERTY_BY_ID (state, property) {
    state.property = property
  },
  SET_IS_VALID_COMMUNITY (state, isValidCommunity) {
    state.propertyAdd.isValidCommunity = isValidCommunity
  },
  SET_IS_FORM_VISIBLE (state, isFormVisible) {
    state.propertyAdd.isFormVisible = isFormVisible
  },
  UPDATE_PROPERTY (state, property) {
    const { liegenschaftId: propertyId } = property
    const index = state.properties.findIndex((e) => e.liegenschaftId === propertyId)
    if (index !== -1) {
      Object.assign(state.properties[index], property)
    }
  },
  DELETE_PROPERTY (state, propertyId) {
    const index = state.properties.findIndex((e) => e.liegenschaftId === propertyId)
    state.properties.splice(index, 1)
  }
}
